import { ResponsiveTableRow, useOverlay } from '@fs/zion-ui'
import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { DmcResponsiveTable } from '../../../common/DmcResponsiveTable'
import FamousPersonDataDialog from './FamousPersonDataDialog'

export default function FamousSearchResultsTable({ persons, removePersonOnDelete, updatePersonOnEdit, countries }) {
  const { t } = useTranslation()
  const [currentPerson, setCurrentPerson] = useState(persons[0])
  const [currentPersonIndex, setCurrentPersonIndex] = useState(0)
  const personDataOverlay = useOverlay()

  useEffect(() => {
    setCurrentPerson(persons[currentPersonIndex])
  }, [currentPersonIndex, persons])

  const onTableRowClick = (person, index) => {
    setCurrentPerson(person)
    setCurrentPersonIndex(index)
    personDataOverlay.open()
  }

  return (
    <>
      <DmcResponsiveTable
        atSizeColumns={{
          default: {
            labels: [
              t('givenName', 'Given Name'),
              t('name.parts.surname', 'Surname'),
              t('tools.lists.headings.birthDate', 'Birth Date'),
              t('birthPlace', 'Birth Place'),
              t('deathDate', 'Death Date'),
              t('deathPlace', 'Death Place'),
              t('biography', 'Biography'),
            ],
            columnWidths: [2, 2, 1, 2, 1, 2, 2],
          },
        }}
        totalColumnCount={7}
        separator={<br />}
        stickyHeader={false}
      >
        {persons.map((person, index) => {
          const personData = JSON.parse(person.personJSON)
          return (
            <ResponsiveTableRow
              key={person.id}
              column1={personData.firstName}
              column2={personData.surname}
              column3={personData.birthDate}
              column4={personData.birthPlace}
              column5={personData.deathDate}
              column6={personData.deathPlace}
              column7={personData.biography}
              onClick={() => onTableRowClick(person, index)}
            />
          )
        })}
      </DmcResponsiveTable>
      {currentPerson && (
        <FamousPersonDataDialog
          person={currentPerson}
          removePersonOnDelete={removePersonOnDelete}
          updatePersonOnEdit={updatePersonOnEdit}
          countries={countries}
          {...personDataOverlay}
        />
      )}
    </>
  )
}
